import SendMessageForm from './SendMessageForm';

export const Empty = {
  component: SendMessageForm,
  props: {
    formId: 'SendMessageForm.Empty.Form',
    messagePlaceholder: 'Send message to Juho…',
    onChange: values => {
      
    },
    onSubmit: values => {
      
    },
    onFocus: () => {
      
    },
    onBlur: () => {
      
    },
  },
  group: 'forms',
};

export const InProgress = {
  component: SendMessageForm,
  props: {
    formId: 'SendMessageForm.InProgress.Form',
    messagePlaceholder: 'Send message to Juho…',
    inProgress: true,
    onSubmit: values => {
      
    },
  },
  group: 'forms',
};

export const Error = {
  component: SendMessageForm,
  props: {
    formId: 'SendMessageForm.Error.Form',
    messagePlaceholder: 'Send message to Juho…',
    sendMessageError: { type: 'error', name: 'ExampleError' },
    onSubmit: values => {
      
    },
  },
  group: 'forms',
};
